const strings = {
  titles: {
    more: { en: 'More', es: 'Más' },
    moreFromTheJournal: {
      en: 'More from the MUSA journal',
      es: 'Más del journal de MUSA',
    },
    vision: { en: 'Vision', es: 'Visión' },
    masterPlan: { en: 'Master plan', es: 'Plan maestro' },
    property: { en: 'Property', es: 'Propiedad' },
    shopProperty: { en: 'Property', es: 'Propiedad' },
    hideaways: { en: 'Hideaways', es: 'Hideaways' },
    customBuild: { en: 'Custom build', es: 'Casas a la medida' },
    customBuildAndLots: {
      en: 'Custom beach homes',
      es: 'Casas de playa a medida',
    },
    liveWork: { en: 'Live-Work', es: 'Estudios' },
    lots: { en: 'Lots', es: 'Lotes' },
    stayNow: { en: 'Stay now', es: 'Visítanos' },
    awakenToParadise: {
      en: 'Awaken to paradise',
      es: 'Despierta con el paraíso',
    },
    freedomIsAJungle: {
      en: 'Freedom Is A Jungle',
      es: 'La libertad es una selva',
    },
    bookNow: { en: 'Book now', es: 'Reserva ahora' },
    basecamp: { en: 'Base Camp', es: 'Base Camp' },
    laCasa: { en: 'Casa MUSA', es: 'Casa MUSA' },
    location: { en: 'Location', es: 'Ubicación' },
    comingSoon: { en: 'Coming Soon', es: 'Ya viene' },
    timeline: { en: 'Timeline', es: 'Timeline' },
    hotelito: { en: 'Hotelito', es: 'Hotelito' },
    faq: { en: 'FAQ', es: 'Preguntas' },
    vault: { en: 'Enter vault', es: 'Vault' },
    membersVault: { en: "Member's Vault", es: 'Miembros Vault' },
    contact: { en: 'Contact', es: 'Contacto' },
    contactMusa: {
      en: 'Follow the MUSA journey',
      es: 'Sigue el viaje de MUSA',
    },
    subscribe: { en: 'Subscribe', es: 'Sucríbete' },
    topic: { en: 'Topic', es: 'Tema' },
    password: { en: 'Password', es: 'Contraseña' },
    viewMoreProperties: {
      en: 'View more properties',
      es: 'Ver más propiedades',
    },
    termsAndConditions: {
      en: 'Terms and Conditions',
      es: 'Términos y condiciones',
    },
    designHotel: {
      en: 'Design Hotel',
      es: 'Hotel de diseño',
    },
    privateResidence: {
      en: 'Private Residence',
      es: 'Residencia privada',
    },
    homes: { en: 'Homes', es: 'Hogares' },
    creators: { en: 'Creators', es: 'Creadores' },
    land: { en: 'Land', es: 'Terreno' },
    origins: { en: 'Origins', es: 'Origins' },
    myMusa: { en: 'My MUSA', es: 'Mi MUSA' },
    art: { en: 'Art', es: 'Arte' },
    journal: { en: 'Journal', es: 'Journal' },
    moreJournalPages: {
      en: 'More from the MUSA journal',
      es: 'Ver más del journal de MUSA',
    },
    phase: { en: 'Phase', es: 'Fase' },
    model: { en: 'Model', es: 'Modelo' },
    liveAtMusa: {
      en: 'Live at MUSA',
      es: 'Vive en MUSA',
    },
    propertiesPageCopyTitle: {
      en: 'To stay or to rent',
      es: 'Quedarse o alquilar',
    },
  },
  cta: {
    turnPhoneHorizontal: {
      en: 'Turn phone horizontal',
      es: 'Gira la pantalla',
    },
    viewTimeline: { en: 'view timeline', es: 'ir a timeline' },
    viewMore: { en: 'view more', es: 'ver más' },
    bookNow: { en: 'book now', es: 'reserva ahora' },
    exploreHotelito: { en: 'explore hotelito', es: 'descubre hotelito' },
    viewStays: { en: 'view stays', es: 'ver propiedades' },
    learnMore: { en: 'learn more', es: 'saber más' },
    enter: { en: 'enter', es: 'entrar' },
    subscribeToMailingList: {
      en: 'subscribe to mailing list',
      es: 'suscribirme',
    },
    send: { en: 'send', es: 'enviar' },
    sending: { en: 'sending...', es: 'enviando...' },
    getInTouch: { en: 'get in touch', es: 'comunícate con nosotros' },
    unlockVault: { en: 'unlock the vault', es: 'abrir la bóveda' },
    exitVault: { en: 'close the vault', es: 'cerrar la bóveda' },
    enquireAboutROI: {
      en: 'Enquire about investing',
      es: 'Consulta sobre la inversión',
    },
    enquireAboutThisProperty: {
      en: 'Enquire about this property',
      es: 'Consultar sobre esta propiedad',
    },
  },
  notices: {
    loadingContactForm: {
      en: 'Loading contact form...',
      es: 'Cargando formato de contacto...',
    },
    swipeTimeline: {
      en: 'Select one of the milestones above to find out more',
      es: 'Selecciona un proyecto en el timeline arriba para saber más',
    },
    stayUpToDate: {
      en: 'Stay up to date on progress and important milestones MUSA',
      es: 'Mantente al tanto de como avanzamos en MUSA',
    },
    contactSuccess: {
      en: 'Thank you! Your message was sent.',
      es: 'Gracias. Tu mensaje fue enviado.',
    },
    contactError: {
      en: 'Sorry! There was an error sending your message.',
      es: 'Lo sentimos. Hubo un error al error tu mensaje.',
    },
    vaultSubheader: {
      en:
        'Turn curiosity into possibility and register your interest to join our hidden oasis.',
      es: 'Regístrate para unirte a nuestro oasis secreto.',
    },
    vaultText: {
      en:
        "By entering the member's vault, you will unlock exciting opportunities to uncover our  masterplan, witness the realisation of our vision as it  comes to life, and  connect  with like-minded creatives, entrepreneurs and adventurers. Seek and you shall find – to request access, contact us, and we will reach out to you shortly. With the privacy of our lost world in mind, all applications are carefully reviewed to ensure the highest level of security for our community.",
      es:
        'Al unirte al Member’s Vault, tendrás acceso al masterplan y podrás ser testigo de cómo se materializa esta visión, conéctate con creativos, emprendedores y aventureros de ideas afines. Para solicitar acceso,  contáctanos  y nos comunicaremos contigo a la brevedad. Todas las aplicaciones son revisadas cuidadosamente para garantizar el más alto nivel de seguridad y privacidad para la comunidad MUSA',
    },
    loginError: {
      en: 'Sorry, wrong password!',
      es: '¡Lo sentimos, contraseña incorrecta!',
    },
    stayNowPageIntro: {
      en:
        'In prelude to the upcoming Hotelito opening 2022, stay now in one of two inspiring abodes for the modern nomad and be one of the first to experience life at MUSA.',
      es:
        'Previo a la apertura de Hotelito en 2022 hospédate ya en uno de los dos alojamientos para el nómada moderno y sé una de las primeras personas en descubrir MUSA.',
    },
    propertiesPageIntro: {
      en:
        'Custom homes by visionary designer Andrés Saavedra. Live in a community that enables you to re-emerge in nature and connect with others who have a passion for discovery and intention.',
      es:
        'Hogares personalizados por el diseñador visionario Andrés Saavedra. Vive en una comunidad que te permite renacer en la naturaleza y conectarte con otros que tienen una pasión por el descubrimiento y la intención.',
    },
    propertiesPageCopy: {
      en:
        "Enjoy the spoils of MUSA's Hotel Residence Club which offers specialised property and rental management. While you're here, enjoy the perks of owning at MUSA which keeps you enjoying your vacation as if you were a Hotel Guest. While you're away, enjoy a healthy 10% annual return on your investment. We take care of the property, manage the rentals as if it were part of the Hotel inventory and market your home so passive returns come your way.",
      es:
        'Disfruta de los beneficios del Club de Residencia del Hotel MUSA, que ofrece servicios especializados de gestión de propiedades y alquileres. Mientras estés aquí, aprovecha las ventajas de ser propietario en MUSA, lo que te permite disfrutar de tus vacaciones como si fueras un huésped de hotel. Mientras estás ausente, obtén un saludable retorno anual del 10% en tu inversión. Nosotros nos encargamos de la propiedad, gestionamos los alquileres como si formaran parte del inventario del hotel y promocionamos tu hogar para que obtengas ingresos pasivos.',
    },
  },
  labels: {
    name: { en: 'Name', es: 'Nombre' },
    email: { en: 'Email', es: 'Email' },
    telephone: { en: 'Phone', es: 'Teléfono' },
    subject: { en: 'Subject', es: 'Asunto' },
    message: { en: 'Message', es: 'Mensaje' },
    salesDirector: { en: 'Sales Director', es: 'Directora de ventas' },
    coming: { en: 'Coming', es: 'Viene' },
  },
  meta: {
    contactTitle: {
      en: 'Contact | MUSA',
      es: 'Contacto | MUSA',
    },
    contactDescription: {
      en: 'Contact us',
      es: 'Contáctanos',
    },
    vaultTitle: {
      en: 'Enter the Vault to find out more | MUSA',
      es: 'Enter the Vault to find out more | MUSA',
    },
    vaultDescription: {
      en:
        'Register your interest and learn more about joining the community. Discover real estate',
      es:
        'Register your interest and learn more about joining the community. Discover real estate',
    },
  },
};

const defaultLocale = 'en';

export const tr = (type, key, locale) =>
  strings[type][key] ? strings[type][key][locale || defaultLocale] : key;
